export default __webpack_public_path__ + "d7ccce3590b97101bb092f3c4f8d9669.svg";